import DynamicContent from './DynamicContent';
import Communication from './Communication';
import LinguiseSwitcher from './LinguiseSwitcher';

const globalCurrent = document.currentScript;

async function mainLinguiseConfigLoader(config, readyCallback) {
    let api_key = config.apiKey;

    const currentScript = document.currentScript || globalCurrent;
    if (currentScript && !api_key) {
        const url = new URL(currentScript.src);

        api_key = url.searchParams.get("d");
    }

    if (!api_key && !Communication._stored_pkey) {
        throw new Error("Linguise: cannot retrieve domain configuration, disabling dynamic content");
    }

    Communication.setPublicKey(api_key);
    const currentConfig = await Communication.getConfig();
    if (!currentConfig) {
        throw new Error("Linguise: cannot retrieve domain configuration, disabling dynamic content");
    }
    currentConfig.public_key = Communication._stored_pkey;
    readyCallback(currentConfig);
}

function getLinguiseConfigsVarsLoader() {
    if (!window.linguise_configs) {
        return;
    }

    const baseConfig = window.linguise_configs.vars.configs;
    if (!baseConfig) {
        return false;
    }

    const dynamicConfig = baseConfig.dynamic_translations;
    const enabled = dynamicConfig ? dynamicConfig.enabled : 0;
    const isDebug = baseConfig.debug === 1;
    const isEnabled = typeof enabled === 'string' ? enabled === '1' : enabled === 1;
    if (!isEnabled) {
        return false;
    }

    const public_key = dynamicConfig ? dynamicConfig.public_key : '';
    if (!public_key) {
        // No public key, no dynamic translations
        isDebug && console.warn('Linguise: No public key provided, dynamic translations are disabled.');
        return false;
    }

    const configLoader = async (config, callback) => {
        const remappedLangauges = [];
        for (const lang in baseConfig.languages) {
            remappedLangauges.push({
                code: lang,
                name: baseConfig.languages[lang],
            });
        }

        const remappedConfig = {
            public_key: public_key,
            dynamic_translations: {
                enabled: isEnabled,
            },
            language: baseConfig.default_language || baseConfig.language_default,
            languages: remappedLangauges,
            debug: isDebug,
            url: baseConfig.base_url,
        }
        callback(remappedConfig);
    }

    return [configLoader, baseConfig.translate_host];
}

function initDynamicContent() {
    const varsConfigs = getLinguiseConfigsVarsLoader();

    // False means that the config exist, but it's not enabled
    if (varsConfigs === false) {
        // Dynamic content is disabled
        return;
    }

    if (Array.isArray(varsConfigs) && varsConfigs.length === 2) {
        new DynamicContent(varsConfigs[0], varsConfigs[1]);
    } else {
        new DynamicContent(mainLinguiseConfigLoader);
    }
}

/**
 * Load the switcher
 * @param {HTMLScriptElement | null} currentScript the current script
 */
async function loadSwitcher(currentScript) {
    const switcher = new LinguiseSwitcher(currentScript);
    let shouldRun = true;
    if (currentScript) {
        const url = new URL(currentScript.src);
        if (url.searchParams.get('hide') === '1') {
            shouldRun = false;
        }
        Communication.setPublicKey(url.searchParams.get("d"));
    }

    if (shouldRun) {
        await switcher.initialize();
    }
}

if (document.readyState !== 'loading') {
    loadSwitcher(globalCurrent);
    initDynamicContent();
} else {
    document.addEventListener('DOMContentLoaded', () => {
        loadSwitcher(globalCurrent);
        initDynamicContent();
    });
}
